<template>
  <div>
    <OffCanvasRoot />
    <!-- Markup shared across all pages, ex: NavBar -->
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
</template>